<template>
  <div id="firmwareUpdate">
    <el-dialog
      :title="$t('FirmwareVersion')"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="viewClose"
    >
      <div class="updateBox">
        <div class="printeUpdateBox">
          <div class="boxLeft">
            <img :src="printe.img"/>
          </div>
          <div class="boxRight">
            <div class="rightModel">
              <div class="modelLeft">{{printe.model}}</div>
              <!-- <div class="modelRight" @click="help(printe.help_url)">
                <span>{{ $t('ViewWiki') }}</span>
                <img src="../../../assets/imgs/square.png"/>
              </div> -->
            </div>
            <div class="rightCurVer">
              <div class="label">{{ $t('FirmwareVersion') }}</div>
              <div class="version">{{printe.currentVersion}}</div>
            </div>
            <div class="rightLastVer">
              <div class="label">{{$t('latest_version')}}</div>
              <div class="version">
                <div class="versionLeft">
                  {{printe.latestVersion}}
                </div>
                <div v-show="printe.need_update == '0'||printe.need_update == '1'" class="priBtn" :class="printe.need_update == '1' ? '':'disableBtn'" @click="handleUpdate">
                  {{$t('update_now')}}
                </div>
                <div v-show="printe.need_update == '2'" class="updateLabel">
                  {{formmatStatus(printe.updateStatus)}}{{printe.progress ? `${printe.progress}%`:''}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="boxUpdateBox" v-for="(item,index) of boxs" :key="index">
          <div class="boxLeft">
            <img :src="item.img"/>
          </div>
          <div class="boxRight">
            <div class="rightModel">
              <div class="modelLeft">{{$t('ace_pro')}}{{index+1}}</div>
              <!-- <div class="modelRight">
                <span>在线帮助</span>
                <img src="../../../assets/imgs/square.png"/>
              </div> -->
            </div>
            <div class="rightCurVer">
              <div class="label">{{ $t('FirmwareVersion') }}</div>
              <div class="version">{{item.currentVersion}}</div>
            </div>
            <div class="rightLastVer">
              <div class="label">{{$t('latest_version')}}</div>
              <div class="version">
                <div class="versionLeft">
                  {{item.latestVersion}}
                </div>
                <div v-show="item.need_update == '0'||item.need_update == '1'" class="priBtn" :class="item.need_update == '1' ? '':'disableBtn'" @click="handleBoxUpdate(item)">
                  {{$t('update_now')}}
                </div>
                <div v-show="item.need_update == '2'" class="updateLabel">
                  {{formmatStatus(item.updateStatus)}}{{item.progress ? `${item.progress}%`:''}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip">{{$t('update_notice')}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 这里导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import {updateVersion,updateBoxVersion} from "../../../api/network/printer.js"
export default {
  name: "firmwareUpdate",
  // 引入的组件需要注入到对象中
  components: {},
  // 定义props属性
  props: {
    visible: Boolean,
    info: Object
  },
  // 数据层
  data() {
    return {
      dialogVisible: false,
      printe: {
        img: '',
        model: '',
        currentVersion: '',
        latestVersion: '',
        need_update: 0,
        progress: 0,
        updateStatus: 0, //need_update为2时 更新状态
        help_url: ''
      },
      boxs:[],
      box: {
        id: '',
        img: '',
        model: '',
        currentVersion: '',
        latestVersion: '',
        need_update: 0,
        progress: 0,
        updateStatus: 0 //need_update为2时 更新状态
      }
    };
  },
  computed: {
    cur_printer() {
      return this.$store.getters.GET_CUR_PRINTER;
    },
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val;
    },
    dialogVisible: function (val) {
      if (val) {
        // this.name = this.rename;
        this.getUpdateInfo();
      } else {
        let curPrinter = JSON.parse(JSON.stringify(this.$store.getters.GET_CUR_PRINTER));
        if(curPrinter && curPrinter.version.updateStatus == 3 || curPrinter.version.updateStatus == 4 || curPrinter.version.updateStatus == 5) {
          curPrinter.version.need_update = 0;
          curPrinter.version.updateStatus = '';
          curPrinter.version.progress = '';
        }
        curPrinter.multi_color_box_version?.forEach((item,index) => {
          if(curPrinter && curPrinter.multi_color_box_version[index].updateStatus == 3 || curPrinter.multi_color_box_version[index].updateStatus == 4 || curPrinter.multi_color_box_version[index].updateStatus == 5) {
            curPrinter.multi_color_box_version[index].need_update = 0;
            curPrinter.multi_color_box_version[index].updateStatus = '';
            curPrinter.multi_color_box_version[index].progress = '';
          }
        })
        this.$store.commit('SET_CUR_PRINTER', curPrinter);
        
        if(this.info && Object.keys(this.info).length > 0) {
          let cloudList = JSON.parse(
            JSON.stringify(this.$store.getters.GET_CLOUD_PRINTER_LIST)
          );
          let idx = cloudList.findIndex((item) => item.key == this.info.key);
          if(idx != -1) {
            if(cloudList[idx].version.updateStatus == 3 || cloudList[idx].version.updateStatus == 4 || cloudList[idx].version.updateStatus == 5) {
              cloudList[idx].version.need_update = 0;
              cloudList[idx].version.updateStatus = '';
              cloudList[idx].version.progress = '';
            }
            cloudList[idx].multi_color_box_version?.forEach((item,index) => {
              if(cloudList[idx].multi_color_box_version[index].updateStatus == 3 || cloudList[idx].multi_color_box_version[index].updateStatus == 4 || cloudList[idx].multi_color_box_version[index].updateStatus == 5) {
                cloudList[idx].multi_color_box_version[index].need_update = 0;
                cloudList[idx].multi_color_box_version[index].updateStatus = '';
                cloudList[idx].multi_color_box_version[index].progress = '';
              }
            })
          }
          this.$store.commit("SET_CLOUD_PRINTER_LIST", cloudList);
        }
      }
    },
    cur_printer: {
      deep: true,
      handler(newval, oldval) {
        this.getUpdateInfo();
      }
    },
    info: {
      deep: true,
      handler(newval, oldval) {
        this.getUpdateInfo();
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  deactivated() {
    this.viewClose();
  },
  // 方法
  methods: {
    help(url) {
      
    },
    formmatStatus(val) {
      let map = {
        1: this.$t('start_update'),
        2: this.$t('downloading'),
        3: this.$t('update_success'),
        4: this.$t('update_failure'),
        5: this.$t('download_failure'),
        6: this.$t('updating'),
        7: this.$t('cancel_update')
      };
      return map[val];
    },
    handleUpdate() {
      if(this.printe.need_update == 0) {
        return;
      }
      let id = undefined;
      if(this.info && Object.keys(this.info).length > 0) {
        id = this.info.id;
      } else {
        id = this.cur_printer?.id;
      }
      updateVersion({id: id,target_version:this.printe.latestVersion}).then((res) => {
        if(res.code == 1) {
          if(res.data?.need_update == 0) {
            this.$message.error(this.$t('updated_refresh_to_view'));
          }
        }
      })
    },
    handleBoxUpdate(item) {
      if(item.need_update == 0) {
        return;
      }
      let id = undefined;
      if(this.info && Object.keys(this.info).length > 0) {
        id = this.info.id;
      } else {
        id = this.cur_printer?.id;
      }
      updateBoxVersion({id: id,box_id:item.id}).then((res) => {
        if(res.code == 1) {
          if(res.data?.need_update == 0) {
            this.$message.error(this.$t('updated_refresh_to_view'));
          }
        }
      })
    },
    viewClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    getUpdateInfo() {
      // 处理打印机
      let curPrinter = undefined;
      if(this.info && Object.keys(this.info).length > 0) {
        curPrinter = Object.assign({},this.info);
      } else {
        curPrinter = this.$store.getters.GET_CUR_PRINTER
      }
      // let curPrinter = this.$store.getters.GET_CUR_PRINTER;
      if(curPrinter && curPrinter.version) {
        // console.log('curPrinter.version.need_update',curPrinter)
          this.printe.help_url = curPrinter.help_url
          this.printe.img = curPrinter.version.img;
          this.printe.model = curPrinter.model;
          this.printe.currentVersion = curPrinter.version.firmware_version;
          this.printe.latestVersion = curPrinter.version.target_version;
          this.printe.need_update = curPrinter.version.need_update;
          this.printe.progress = curPrinter.version.progress ? curPrinter.version.progress : '';
          this.printe.updateStatus = curPrinter.version.updateStatus ? curPrinter.version.updateStatus : '';
      }
      // 处理盒子
      this.boxs = [];
      if(curPrinter && curPrinter.multi_color_box && Object.keys(curPrinter.multi_color_box).length > 0) {
        curPrinter.multi_color_box_version?.forEach(item => {
        console.log('item.need_update',item)
          
          let obj = {};
          obj.id = item.box_id;
          obj.img = item.img;
          obj.currentVersion = item.firmware_version;
          obj.latestVersion = item.target_version;
          obj.need_update = item.need_update;
          obj.progress = item.progress ? item.progress : '';
          obj.updateStatus = item.updateStatus ? item.updateStatus : '';
          this.boxs.push(obj);
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入公共css类 */
#firmwareUpdate {
  :deep(.el-dialog__header) {
    text-align: center;
    padding-top: 10px;
    .el-dialog__title {
      // height: 18px;
      
      // font-weight: normal;
      // font-size: 13px;
      // line-height: 18px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  :deep(.el-dialog__body) {
    padding: 0px;
  }
  :deep(.el-dialog__footer) {
    padding-top: 20px;
  }
  :deep(.el-dialog) {
    width: 560px;
    box-sizing: border-box;
  }
  .updateBox {
    padding: 20px 20px 30px 20px;
    .printeUpdateBox {
      width: 100%;
      height: 168px;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid var(--workbench-left-division-line);
      padding: 20px;
      display: flex;
      box-sizing: border-box;
      margin-bottom: 12px;
      .boxLeft {
        width: 160px;
        height: 120px;
        margin-right: 16px;
        img{
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
      .boxRight {
        width:324px;
        .rightModel {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          .modelLeft {
            
            font-weight: 700;
            font-size: 15px;
            color: var(--second-text-color);
            line-height: 24px;
          }
          .modelRight {
            display: flex;
            align-items: center;
            cursor: pointer;
            span {
              
              font-weight: normal;
              font-size: 13px;
              color: var(--VI-color);
              line-height: 24px;
              margin-right: 4px;
            }
            img{
              width: 16px;
              height: 16px;
            }
          }
        }
        .rightCurVer {
          margin-bottom: 8px;
          .label {
            height: 24px;
            
            font-weight: normal;
            font-size: 14px;
            color: var(--three-text-color);
            line-height: 24px;
          }
          .version {
            height: 20px;
            
            font-weight: normal;
            font-size: 14px;
            color: var(--second-text-color);
            line-height: 20px;
          }
        }
        .rightLastVer {
          margin-bottom: 8px;
          .label {
            height: 24px;
            
            font-weight: normal;
            font-size: 14px;
            color: var(--three-text-color);
            line-height: 24px;
          }
          .version {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 28px;
            .versionLeft {
              height: 20px;
              
              font-weight: normal;
              font-size: 14px;
              color: var(--second-text-color);
              line-height: 20px;
            }
            .priBtn {
              width: 148px;
              font-size: 14px;
            }
            .disableBtn {
              cursor: not-allowed;
              background: var(--VI-disColor);
            }
            .updateLabel {
              height: 22px;
              
              font-weight: normal;
              font-size: 14px;
              color: var(--VI-color);
              line-height: 22px;
            }
          }
        }
      }
    }
    .boxUpdateBox {
      width: 100%;
      height: 168px;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid var(--workbench-left-division-line);
      padding: 20px;
      display: flex;
      box-sizing: border-box;
      margin-bottom: 12px;
      .boxLeft {
        width: 160px;
        height: 120px;
        margin-right: 16px;
        img{
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
      .boxRight {
        width:324px;
        .rightModel {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          .modelLeft {
            
            font-weight: 700;
            font-size: 15px;
            color: var(--second-text-color);
            line-height: 24px;
          }
          .modelRight {
            display: flex;
            align-items: center;
            span {
              
              font-weight: normal;
              font-size: 13px;
              color: var(--VI-color);
              line-height: 24px;
              margin-right: 4px;
            }
            img{
              width: 16px;
              height: 16px;
            }
          }
        }
        .rightCurVer {
          margin-bottom: 8px;
          .label {
            height: 24px;
            
            font-weight: normal;
            font-size: 14px;
            color: var(--three-text-color);
            line-height: 24px;
          }
          .version {
            height: 20px;
            
            font-weight: normal;
            font-size: 14px;
            color: var(--second-text-color);
            line-height: 20px;
          }
        }
        .rightLastVer {
          margin-bottom: 8px;
          .label {
            height: 24px;
            
            font-weight: normal;
            font-size: 14px;
            color: var(--three-text-color);
            line-height: 24px;
          }
          .version {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 28px;
            .versionLeft {
              height: 20px;
              
              font-weight: normal;
              font-size: 14px;
              color: var(--second-text-color);
              line-height: 20px;
            }
            .priBtn {
              width: 148px;
              font-size: 14px;
            }
            .disableBtn {
              cursor: not-allowed;
              background: var(--VI-disColor);
            }
            .updateLabel {
              height: 22px;
              
              font-weight: normal;
              font-size: 14px;
              color: var(--VI-color);
              line-height: 22px;
            }
          }
        }
      }
    }
    .tip {
      height: 18px;
      
      font-weight: normal;
      font-size: 13px;
      color: var(--first-text-color);
      line-height: 18px;
    }
  }
}
</style>
